export default __webpack_public_path__ + "static/media/2.09f40a03.webp";